import { useNavigate } from "react-router-dom";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
  Button,
  IconButton,
} from "@mui/material";
import SearchBar from "../../components/SearchBar";
import Pagination from "../../components/Panigation";
import { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import { useDeleteLoactionMutation, useLazyGetLoactionQuery } from "../../services/loaction";
import { showError, showToast } from "../../constants/toasts";
import DeleteConfirmModal from "../../Modals/deleteConfirmModal";
import IfCan from "../../components/IfCan";
import { isValidInput } from "../../utils/validations";

const LocationIntelligence = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [page, setPage] = useState(1);
  const [data, setData] = useState<any[]>([]);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [getLoaction] = useLazyGetLoactionQuery();
  const [deleteLoaction] = useDeleteLoactionMutation()
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [deleteOpen, setDeleteOpen] = useState(false);

  const getLoactionList = async () => {
    setIsLoading(true);
    try {
      const response = await getLoaction({
        length: 10,
        start: page,
        search: debouncedSearchTerm,
      }).unwrap();
      if (response.status === 200) {
        setData(response?.data?.response_object || []);
        setTotalCount(response?.data?.total_records || 0);
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getLoactionList();
  }, [debouncedSearchTerm, page]);

  const handleDelete = async () => {
    if (!selectedId) return;
    try {
      await deleteLoaction({ id: selectedId }).unwrap();
      showToast("loaction deleted successfully");
      getLoactionList()
    } catch (e: any) {
      showError(e?.data?.message || "Failed to delete loaction");
    }
    setDeleteOpen(false);
    setSelectedId(null);
  };



  const columns = [
    { id: "address", label: "Most Visited Location" },
    { id: "radius", label: "Radius Trigger" },
    { id: "location_type", label: "Location Type" },
    { id: "suggestion", label: "Suggestions" },
  ];

  const [searchTerm, setSearchTerm] = useState("");

  const totalPages = Math.ceil(totalCount / 10);

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
  };

  return (
    <>
      <>
          <>
            <div className="main_title">
              <h1>Location Intelligence</h1>
              <p>
                <span onClick={() => navigate("/dashboard")}>Dashboard</span> -
                Location Intelligence
              </p>
            </div>

            <div className="cards">
              <div className="table_header">
                <div className="left_s">
                  <Box className="search_box">
                    <SearchBar
                      placeholder="Search..."
                      searchTerm={searchTerm}
                      setDebouncedSearchTerm={setDebouncedSearchTerm}
                      value={searchTerm}
                      onCross={() => setSearchTerm("")}
                      onChange={(val: any) => {
                        if (isValidInput(val.target.value)) {
                          setSearchTerm(val.target.value);
                        }
                      }}
                    />
                  </Box>
                </div>
                <IfCan module="Location Intelligence" action="add_edit">
                  <div className="right_s">
                    <Button
                      className="btn btn_primary"
                      onClick={() => navigate("/location-intelligence/add-location")}
                    >
                      <AddIcon /> Add{" "}
                    </Button>
                  </div>
                </IfCan>
              </div>
              <TableContainer className="table_container">
                <Table>
                  <TableHead>
                    <TableRow hover>
                      {columns.map((col) => (
                        <TableCell key={col.id}>{col.label}</TableCell>
                      ))}
                      <TableCell>Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {data.map((row) => (
                      <TableRow hover key={row.id}>
                        <TableCell>{row.address}</TableCell>
                        <TableCell>{row.radius}m</TableCell>
                        <TableCell>{row.location_type}</TableCell>
                        <TableCell>
                          {row.suggestion ? (
                            <span
                              style={{
                                padding: "2px 6px",
                                background: "#f0f0f0",
                                borderRadius: 4,
                                display: "inline-block",
                                fontSize: 12,
                              }}
                            >
                              {row.suggestion}
                            </span>
                          ) : (
                            <span style={{ color: "#999", fontSize: 12 }}>No suggestions</span>
                          )}
                        </TableCell>
                        <TableCell>
                          <div className="table_actions v2">
                            <IfCan module="Location Intelligence" action="add_edit">
                              <Box>
                                <IconButton
                                  onClick={() =>
                                    navigate(`/location-intelligence/edit-location/${row?.id}`)
                                  }
                                >
                                  <img
                                    src="/static/images/edit2_icon.svg"
                                    alt="Edit"
                                  />
                                </IconButton>
                              </Box>
                            </IfCan>
                            <IfCan module="Location Intelligence" action="delete">
                              <Box>
                                <IconButton onClick={() => { setSelectedId(row.id); setDeleteOpen(true); }}>
                                  <img
                                    src="/static/images/trash2_icon.svg"
                                    alt="Delete"
                                  />
                                </IconButton>
                              </Box>
                            </IfCan>
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              {totalCount > 0 && (
                <Pagination
                  module={data}
                  page={page}
                  onPageChange={handlePageChange}
                  totalPages={totalPages}
                  totalCount={totalCount}
                  setPage={setPage}
                />
              )}
            </div>
          </>
      </>
      <IfCan module="Location Intelligence" action="delete">
        <DeleteConfirmModal
          open={deleteOpen}
          setOpen={setDeleteOpen}
          handleDelete={handleDelete}
          title="Are you sure you want to delete this location?"
          message="This action cannot be undone."
        />
      </IfCan>
    </>
  );
};

export default LocationIntelligence;
